<template>
    <div class="audit-status-modify">
        <!-- 页面标题 -->
        <div class="page-header">
            <h2 class="page-title">中标/修改审核状态</h2>
        </div>
        <!-- 页面内容 -->
        <div class="page-content">
              <div class="page-content-item" @click="handleSendBackProject">
                <span>项目退回</span>
            </div>
            <div class="page-content-item" @click="handleSendBackBidInvitationDocument">
                <span>文件退回</span>
            </div>
            <div class="page-content-item" @click="handleSendBackBidSection">
                <span>标段退回</span>
            </div>
            <div class="page-content-item" @click="handleSendBackReport">
                <span>报告退回</span>
            </div>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="85%" :close-on-click-modal="false"
            class="sendback-dialog">
            <div class="dialog-toolbar">
                <el-input v-model="dialogQuery.keyword" clearable placeholder="请输入名称关键词" class="dialog-search"
                    @keyup.enter.native="handleDialogSearch"></el-input>
                <el-button type="primary" @click="handleDialogSearch">查询</el-button>
            </div>
            <el-table v-loading="dialogLoading" :data="dialogTableData" border stripe class="dialog-table">
                <el-table-column type="index" label="#" width="60" align="center"></el-table-column>
                <template v-if="dialogType === 'file'">
                    <el-table-column prop="bidInvitationDocumentsCode" label="文件编号" min-width="180"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bidInvitationDocumentsName" label="文件名称" min-width="240"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="documentType" label="类型" width="100" align="center">
                        <template slot-scope="scope">
                            {{ getDocumentTypeText(scope.row.documentType) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="createBy" label="创建人" width="160" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
                    <!-- <el-table-column prop="status" label="状态" width="100" align="center">
                        <template slot-scope="scope">
                            {{ getSendBackStatusText(scope.row.status) }}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="reason" label="原因" min-width="220" show-overflow-tooltip></el-table-column>
                </template>
                <template v-else-if="dialogType === 'section'">
                    <el-table-column prop="bidSectionCode" label="标段编号" min-width="180"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bidSectionName" label="标段名称" min-width="240"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createBy" label="创建人" width="160" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
                    <!-- <el-table-column prop="status" label="状态" width="100" align="center">
                        <template slot-scope="scope">
                            {{ getSendBackStatusText(scope.row.status) }}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="reason" label="原因" min-width="220" show-overflow-tooltip></el-table-column>
                </template>
                <template v-else-if="dialogType === 'report'">
                    <el-table-column prop="projectCode" label="项目编号" min-width="180"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="bidSectionName" label="标段名称" min-width="240"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="noticeName" label="公告名称" min-width="280"
                        show-overflow-tooltip></el-table-column>
                    <!-- <el-table-column prop="status" label="状态" width="100" align="center">
                        <template slot-scope="scope">
                            {{ getSendBackStatusTexts(scope.row.status) }}
                        </template>
                    </el-table-column> -->
                </template>
                <template v-else>
                    <el-table-column prop="projectCode" label="项目编号" min-width="180"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="projectName" label="项目名称" min-width="240"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="agencyName" label="代理机构" width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="agencyProjectManagerName" label="项目经理" min-width="160"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="agencyProjectManagerPhone" label="电话" width="140"></el-table-column>
                    <!-- <el-table-column prop="projectType" label="项目类型" width="100" align="center"></el-table-column> -->
                    <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
                    <!-- <el-table-column prop="status" label="状态" width="100" align="center">
                        <template slot-scope="scope">
                            {{ getSendBackStatusText(scope.row.status) }}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="reason" label="原因" min-width="220" show-overflow-tooltip></el-table-column>
                </template>
                <el-table-column label="操作" width="120" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain :loading="actionLoadingId === getRowKey(scope.row)"
                            @click="handleSendBack(scope.row)">
                            退回
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="dialog-pagination">
                <el-pagination @size-change="handleDialogSizeChange" @current-change="handleDialogCurrentChange"
                    :current-page="dialogPagination.currentPage" :page-sizes="[10, 20, 50, 100]"
                    :page-size="dialogPagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="dialogPagination.total"></el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    bidInvitationDocumentList,
    bidSectionList,
    bidProjectList,
    sendBackBidInvitationDocument,
    sendBackBidSection,
    sendBackProject,
    getEvaluationReportList,
    sendBackEvaluationReport

} from '@/api/modules/modifyAuditStatus'
export default {
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            dialogType: 'file',
            dialogLoading: false,
            actionLoadingId: '',
            dialogQuery: {
                keyword: ''
            },
            dialogTableData: [],
            dialogPagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
                pages: 0
            }
        }
    },
    mounted() {
    },
    methods: {
        //  文件退回
        handleSendBackBidInvitationDocument() {
            this.openDialog('file')
        },
        //标段退回
        handleSendBackBidSection() {
            this.openDialog('section')
        },
        //项目退回
        handleSendBackProject() {
            this.openDialog('project')
        },
        // 报告退回
        handleSendBackReport() {
            this.openDialog('report')
        },


        openDialog(type) {
            this.dialogType = type
            this.dialogVisible = true
            this.dialogQuery.keyword = ''
            this.dialogPagination.currentPage = 1
            this.dialogPagination.pageSize = 10
            this.dialogTableData = []
            this.dialogPagination.total = 0

            if (type === 'file') this.dialogTitle = '文件退回'
            else if (type === 'section') this.dialogTitle = '标段退回'
            else if (type === 'report') this.dialogTitle = '报告退回'
            else this.dialogTitle = '项目退回'

            this.fetchDialogList()
        },

        handleDialogSearch() {
            this.dialogPagination.currentPage = 1
            this.fetchDialogList()
        },

        handleDialogSizeChange(size) {
            this.dialogPagination.pageSize = size
            this.dialogPagination.currentPage = 1
            this.fetchDialogList()
        },

        handleDialogCurrentChange(page) {
            this.dialogPagination.currentPage = page
            this.fetchDialogList()
        },

        async fetchDialogList() {
            this.dialogLoading = true
            try {
                const pageNum = this.dialogPagination.currentPage
                const pageSize = this.dialogPagination.pageSize
                const keyword = this.dialogQuery.keyword || ''

                let res
                if (this.dialogType === 'file') {
                    res = await bidInvitationDocumentList({ bidInvitationDocumentName: keyword, pageNum, pageSize })
                } else if (this.dialogType === 'section') {
                    res = await bidSectionList({ bidSectionName: keyword, pageNum, pageSize })
                } else if (this.dialogType === 'report') {
                    res = await getEvaluationReportList({ bidSectionName: keyword, pageNum, pageSize })
                } else {
                    res = await bidProjectList({ projectName: keyword, pageNum, pageSize })
                }

                if (res.code === 200) {
                    const data = res.data || {}
                    this.dialogTableData = data.records || []
                    this.dialogPagination.total = data.total || 0
                    this.dialogPagination.pages = data.pages || 0
                } else {
                    this.$message.error(res.msg || '获取列表失败')
                }
            } catch (e) {
                console.error(e)
                this.$message.error('获取列表失败')
            } finally {
                this.dialogLoading = false
            }
        },

        getRowKey(row) {
            if (this.dialogType === 'file') return row.bidInvitationDocumentsCode || ''
            if (this.dialogType === 'section') return row.bidSectionCode || ''
            if (this.dialogType === 'report') return row.bidEvaluationReportGuid || ''
            return row.projectCode || ''
        },

        handleSendBack(row) {
            const key = this.getRowKey(row)
            if (!key) {
                this.$message.error('缺少业务编码，无法退回')
                return
            }
            this.$confirm('确认退回当前数据？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnClickModal: false,
                closeOnPressEscape: false
            }).then(async () => {
                this.actionLoadingId = key
                try {
                    let res
                    if (this.dialogType === 'file') {
                        res = await sendBackBidInvitationDocument({ bidInvitationDocumentCode: key })
                    } else if (this.dialogType === 'section') {
                        res = await sendBackBidSection({ bidSectionCode: key })
                    } else if (this.dialogType === 'report') {
                        res = await sendBackEvaluationReport({ bidEvaluationReportGuid: key })
                    } else {
                        res = await sendBackProject({ projectCode: key })
                    }

                    if (res.code === 200) {
                        this.$message.success('退回成功')
                        this.fetchDialogList()
                    } else {
                        this.$message.error(res.msg || '退回失败')
                    }
                } catch (e) {
                    console.error(e)
                    this.$message.error('退回失败')
                } finally {
                    this.actionLoadingId = ''
                }
            }).catch(() => { })
        },

        handleCloseDialog() {
            this.dialogVisible = false
            this.dialogLoading = false
            this.actionLoadingId = ''
        },

        getMaxPopupZIndex() {
            try {
                const selectors = ['.el-dialog__wrapper', '.el-message-box__wrapper', '.v-modal']
                const elements = selectors
                    .map(s => Array.from(document.querySelectorAll(s)))
                    .reduce((acc, cur) => acc.concat(cur), [])

                let maxZIndex = 0
                elements.forEach(el => {
                    const zIndex = parseInt(window.getComputedStyle(el).zIndex, 10)
                    if (!Number.isNaN(zIndex)) {
                        maxZIndex = Math.max(maxZIndex, zIndex)
                    }
                })

                return maxZIndex || 2000
            } catch (e) {
                return 2000
            }
        },

        getDocumentTypeText(type) {
            const map = {
                1: '文件',
                2: '补遗书',
                3: '澄清文件'
            }
            return map[type] || '-'
        },

        getSendBackStatusText(status) {
            const map = {
                0: '待处理',
                1: '已处理'
            }
            return map[status] || '-'
        },

        getSendBackStatusTexts(status) {
            const map = {
                0: '暂存',
                1: '提交'
            }
            return map[status] || '-'
        },

    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common-page-styles.less';

.common-list-page-styles(audit-status-modify);

.page-header {
    .warning-text {
        margin-left: 10px;
        color: #F56C6C;
        font-size: 14px;
        font-weight: 500;
    }
}

.page-content {
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    border-radius: 8px;
    margin-top: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.3s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .page-content-item {
        text-align: start;
        color: #303133;
        font-size: 15px;
        font-weight: 600;
        padding: 14px 12px;
        border-radius: 6px;
        border: 1px solid #ebeef5;
        cursor: pointer;
        transition: all .2s ease;

        &:hover {
            background: #f5f7fa;
            border-color: #409EFF;
        }
    }
}

.sendback-dialog {
    .dialog-toolbar {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;
    }

    .dialog-search {
        width: 260px;
    }

    .dialog-table {
        width: 100%;
    }

    .dialog-pagination {
        display: flex;
        justify-content: flex-end;
        padding-top: 12px;
    }
}
</style>
